import axios from 'axios'
import {Loading, Message } from 'element-ui'

let loading
const startLoading = () => {
    loading = Loading.service({
        lock: true,
        target: 'body'
    });
};
const endLoading = () => {
    loading.close();
};
export default {
    Request:function(arrReq,str){   
    startLoading()
    if(str=='basePage'){
        //头部请求内容
      arrReq.push( {Url: "PublicFun/GetWebMenu",Flag: "navs",Param: [{ Name: "nodeNum", Value:"迎新导航" }]})
      arrReq.push( {Url: "PublicFun/GetBillManage",Flag: "CodeImg",Param: [{ Name: "nodeNum", Value:"0107" }]})
    }
    axios.post(`/APIFactory/`,arrReq)
                      .then(res => {
                            endLoading()
                            if(res.data.ErrorCode == 0){
                                if(str=="basePage"){//基础页面（头部、底部、中间内容）
                                    HeaderDataBind(res)
                                    ContentDataBind(res)
                                } 
                                //激活页面
                                if(str=='BaseInfoC'){
                                    ContentDataBind_BaseInfoC(res)
                                }
                                if(str=='FamilyInfoC'){
                                    ContentDataBind_FamilyInfoC (res)
                                }
                                if(str=='PaymentInfoC'){
                                    ContentDataBind_PaymentInfoC (res)
                                }
                                if(str=='InsuranceC'){
                                    ContentDataBind_InsuranceC (res)
                                }
                                if(str=='TravelC'){
                                    ContentDataBind_TravelC (res)
                                }
                                if(str=='OtherInfoC'){
                                    ContentDataBind_OtherInfoC (res)
                                }
                                if(str=='GreenRoadC'){
                                    ContentDataBind_GreenRoadC (res)
                                }
                            }else if(res.data.ErrorCode == 1){
                                endLoading();
                                Message.error({
                                    message:res.data.ErrorMsg,
                                    type:"error",
                                    duration:3000
                                })
                            }
                      }).catch(err => {//指向错误页面之前关闭加载
                          endLoading()
                          Message.error({
                              message:err,
                              type:"error",
                              duration:3000
                          })
                      })
                    }
                  }


// WEBPACK FOOTER //
// ./src/assets/js/request.js